export default {
    name: "BreedersView",
};
